const mediaItems = [
  {
    id: 1,
    title: '星际迷航：新纪元',
    tag: '香蕉视频',
    views: '128.6万',
    rating: '9.2',
    category: '科幻大片',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20style%20image%20with%20dramatic%20lighting%20and%20warm%20tones%2C%20movie%20scene%20atmosphere%2C%20professional%20cinematography%20aesthetic%2C%20rich%20colors%2C%20film%20grain%20texture%2C%20clean%20background%2C%20high%20quality%20visual%20composition&width=800&height=450&seq=media-card-1-2026&orientation=landscape',
  },
  {
    id: 2,
    title: '长安十二时辰',
    tag: '红桃视频',
    views: '96.3万',
    rating: '9.5',
    category: '古装巨制',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20style%20image%20with%20dramatic%20lighting%20and%20warm%20tones%2C%20movie%20scene%20atmosphere%2C%20professional%20cinematography%20aesthetic%2C%20rich%20colors%2C%20film%20grain%20texture%2C%20clean%20background%2C%20high%20quality%20visual%20composition&width=800&height=450&seq=media-card-2-2026&orientation=landscape',
  },
  {
    id: 3,
    title: '奔跑吧第八季',
    tag: '蜜桃视频',
    views: '215.7万',
    rating: '8.8',
    category: '热门综艺',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20style%20image%20with%20dramatic%20lighting%20and%20warm%20tones%2C%20movie%20scene%20atmosphere%2C%20professional%20cinematography%20aesthetic%2C%20rich%20colors%2C%20film%20grain%20texture%2C%20clean%20background%2C%20high%20quality%20visual%20composition&width=800&height=450&seq=media-card-3-2026&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">精选推荐</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">每日精选高清影视内容，热门电影、电视剧、综艺一网打尽</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {mediaItems.map((item) => (
            <div key={item.id} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer">
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">{item.tag}</span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <div className="w-10 h-10 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-600 text-lg"></i>
                  </div>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-0.5 rounded bg-background-950/60 text-accent-300 text-xs font-bold">{item.rating}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{item.category}</span>
                  <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{item.views}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}